import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const Testimonials = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const testimonials = [{
    rating: 5,
    text: "I have purchased Drift multiple times now. My first purchase was made in March 2025. I wanted to wait for the actual impact and the benefit; I didn't want to rush into conclusions. With confidence, I can say that I am so glad that I found Thaura! Reasons why I needed Drift: I was very concerned about the heartburn that I had occasionally (more often than it should happen). I also struggle with constant bloating, stubborn weight (specifically the belly area). Once I started taking Drift, I noticed that the bloating feeling was minimized, almost gone. I truly feel much better in the abdominal area (Before taking this product, I had times when I felt so bloated that it felt like my stomach was up to my chest). Next, my heartburn is gone. Since March, I only felt a 2-3 times light possibility of heartburn, but it wasn't completely established. Last, I noticed better results with my weekly exercises.",
    author: 'Daniel B.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cj8L2GwK5u5pmP2T3d6Ax4/Daniel_B..png'
  }, {
    rating: 5,
    text: "I've tried everything under the sun, but nothing worked like Drift. It got me started on the right track, but my results really took off as I continued. I'm down 15 pounds of pure fat in 6 weeks, and my strength is through the roof. Plus, those stubborn love handles are finally disappearing!",
    author: 'James T.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hbchurjhWhmVtXNkLn7pLv/James_T..png'
  }, {
    rating: 5,
    text: "I was sceptical initially but after having my blood work done that showed hormonal imbalance I thought I'd give it a try, I'm about 9 weeks in now and genuinely feel considerably better, my energy levels have improved significantly and I feel alive again, my confidence has improved and my stamina in the gym.. and out has really increased.",
    author: 'Daniel F.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xhVaNzCdZMrz2oH7qD21BB/Daniel_F..png'
  }, {
    rating: 5,
    text: 'I was ready to give up until I was recommended Drift. Down 19 pounds in 60 days, and my chest finally looks normal again. Worth every penny.',
    author: 'Mark L.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7pZcM4QWbA8Gte3FLboQdz/Mark_L..png'
  }, {
    rating: 5,
    text: 'I am getting my jaw line back and am burning calories like I did when I was younger. My chest fat is reducing in size and I feel fitter.',
    author: 'Edward G.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sstDU4JUTRGLcvcvErHACL/Edward_G..png'
  }, {
    rating: 5,
    text: "My husband was skeptical about trying another supplement, but Drift proved him wrong. He's lost that stubborn belly fat, his energy is amazing, and he's got this powerful confidence I haven't seen in years. I'm loving the new him!",
    author: 'Michelle P.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tnqtFtRTeSfYA7PQfAuVP1/Michelle_P..png'
  }, {
    rating: 5,
    text: 'Fast delivery, product is amazing, does exactly what it says on the tin. On my second order and about to buy a third. People have noticed and commented on the changes and I feel like a new man.',
    author: 'Charles B.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/s3wAYTVDcv9XFi8DbYmsQk/Charles_B..png'
  }, {
    rating: 5,
    text: "I really didn't notice too much until a month and a half in I weighed 13 lbs less.",
    author: 'Gregory T.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hGSdAMDRoCFY4eFyU62QNM/Gregory_T..png'
  }, {
    rating: 5,
    text: "I'm 67 and my energy is like I'm in my 40s.",
    author: 'Frank W.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dgtj5nFLp6DzZFTvmFKfA9/Frank_W..png'
  }, {
    rating: 5,
    text: 'Easy to order and set up subscription. and with in 2 weeks started to see changes and with exercise even better results.',
    author: 'Stephen H.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/87JJhrjkgqBBHE5WFxMrS8/Stephen_H..png'
  }, {
    rating: 5,
    text: 'Great results, seem to notice on the second bottle the bigger difference, slimed down.',
    author: 'Jason M.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/52Mrg2pg8JkCT8QgmcxBnw/Jason_M..png'
  }, {
    rating: 5,
    text: 'This is my first time using Drift, and I noticed a better feeling. Plus, with exercise, I lost 7 lbs. in 4 weeks. I guess this stuff works for my body. I have another order in transit, and I look forward to more results as I take this journey for the next 2 months. SEMPER FI.',
    author: 'John M.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kK465Yt1MGk4PtQhmHqWGn/John_M..png'
  }, {
    rating: 5,
    text: 'Very informative website with lots of positive comments, delivered quickly and well packaged, early days taking them, but do feel better and change seems to be happening.',
    author: 'Brian L.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m1z1V3ACUgSB1RC6JLqd3x/Brian_L..png'
  }, {
    rating: 5,
    text: "Workouts are getting more intense and I feel stronger. Still hoping to see more body recomp but I've just started protocol within last few weeks.",
    author: 'Anthony S.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7uwPA4VCqTaRb5Gbnvm6Y8/Anthony_S..png'
  }, {
    rating: 5,
    text: "The product itself does everything it promises and has helped me enormously in achieving my weight loss targets well ahead of time and also boosted my energy levels and stamina and made gym sessions that much more rewarding. I really can't recommend this product enough.",
    author: 'Victor H.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/whAGG7w5SW2H7UcDgYYj7Y/Victor_H..png'
  }, {
    rating: 5,
    text: 'Only two weeks in, and I can already see the results. My husband, who is 52, was struggling with chest fat, love handles, and belly fat. You can definitely see his chest shrinking.',
    author: 'Jennifer K.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/v5ckHeyG8Th5eNjGfnE8z6/Jennifer_K..png'
  }];
  const testimonialsPerPage = 6;
  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  const currentTestimonials = testimonials.slice(currentPage * testimonialsPerPage, (currentPage + 1) * testimonialsPerPage);
  const goToNextPage = () => {
    setCurrentPage(prev => (prev + 1) % totalPages);
  };
  const goToPrevPage = () => {
    setCurrentPage(prev => (prev - 1 + totalPages) % totalPages);
  };
  return <div data-id="element-231">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-232">
        {currentTestimonials.map((testimonial, index) => <div key={index} className="bg-white p-4 rounded shadow" data-id="element-233">
            <div className="flex justify-center text-yellow-400 mb-2" data-id="element-234">
              {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-235" />)}
            </div>
            <p className="text-sm mb-2 leading-relaxed" data-id="element-236">{testimonial.text}</p>
            <div className="flex items-center mt-3" data-id="element-237">
              {testimonial.image && <div className="w-8 h-8 rounded-full overflow-hidden mr-2" data-id="element-238">
                  <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-239" />
                </div>}
              {testimonial.author && <p className="text-sm font-bold" data-id="element-240">- {testimonial.author}</p>}
            </div>
          </div>)}
      </div>
      <div className="flex justify-center mt-6 space-x-4" data-id="element-241">
        <button onClick={goToPrevPage} className="bg-gray-200 hover:bg-gray-300 rounded-full p-2 transition-colors testimonial-nav" aria-label="Previous testimonials" type="button" data-id="element-242">
          <ChevronLeftIcon className="w-6 h-6" data-id="element-243" />
        </button>
        <div className="flex items-center" data-id="element-244">
          <span className="text-sm text-gray-600" data-id="element-245">
            Page {currentPage + 1} of {totalPages}
          </span>
        </div>
        <button onClick={goToNextPage} className="bg-gray-200 hover:bg-gray-300 rounded-full p-2 transition-colors testimonial-nav" aria-label="Next testimonials" type="button" data-id="element-246">
          <ChevronRightIcon className="w-6 h-6" data-id="element-247" />
        </button>
      </div>
    </div>;
};
export default Testimonials;